<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="id">
                <span slot="label" ><a-tooltip>{{$t('订单编号')}}<template slot="title"></template></a-tooltip></span>
                <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="18" :placeholder="$t('订单编号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="outTradeNo">
                <span slot="label" ><a-tooltip>{{$t('三方订单号')}}<template slot="title"></template></a-tooltip></span>
                <a-input v-model="queryParam.outTradeNo" @pressEnter="handleQuery" :maxLength="40" placeholder="请输入三方订单号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="orderStatusList">
                <span slot="label" ><a-tooltip>{{$t('订单状态')}}<template slot="title"></template></a-tooltip></span>
                <a-select  mode="multiple" placeholder="请选择订单状态"
                           @change="orderStatusListChange"
                           style="width: 100%" v-model="queryParam.orderStatusList" allowClear>
                  <a-select-option v-for="(item, index) in this.customDict.OrderSellMallStatusEnum" :value="item.type"
                                   :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item prop="buyerId">
                  <span slot="label" ><a-tooltip>{{$t('买家ID')}}<template slot="title"></template></a-tooltip></span>
                  <a-input v-model="queryParam.buyerId" @pressEnter="handleQuery" :maxLength="20" placeholder="请输入买家ID" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="买家信息" prop="userMobile">
                  <a-input v-model="queryParam.userMobile" @pressEnter="handleQuery" :maxLength="20" placeholder="请输入手机号" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('是否催发货')" prop="isRemind">
                  <a-select  :placeholder="$t('请选择')+$t('是否催发货')"
                             style="width: 100%" v-model="queryParam.isRemind" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type"
                                     :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
<!--              <a-col :md="6" :sm="24">
                <a-form-item label="商品分类" prop="categoryId">
                  <a-tree-select v-model="queryParam.categoryId" style="width: 100%"
                                 :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="cateOptions" placeholder="请选择商品分类"
                                 :replaceFields="{ children: 'children', title: 'categoryName', key: 'id', value: 'id' }"
                                 tree-default-expand-all allow-clear>
                  </a-tree-select>
                </a-form-item>
              </a-col>-->
              <a-col :md="6" >
                <a-form-item prop="goodsId" label="商品编号">
                  <a-input v-model="queryParam.goodsId" @pressEnter="handleQuery" :maxLength="100" placeholder="请输入商品编号" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item prop="goodsName">
                    <span slot="label" >
                      <a-tooltip>
                        {{$t('商品名称')}}
                        <template slot="title">
                          请输入商品关键词,多个关键词之间用英文逗号分隔
                        </template>
                      </a-tooltip>
                    </span>
                  <a-input v-model="queryParam.goodsName" @pressEnter="handleQuery" :maxLength="100" placeholder="请输入商品关键词,多个关键词之间用英文逗号分隔" allow-clear/>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="下单开始时间" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="下单结束时间" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="发货开始时间" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.deliveryBeginTime"
                                 valueFormat="YYYY-MM-DD" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="发货结束时间" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.deliveryEndTime"
                                 valueFormat="YYYY-MM-DD" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="支付方式" prop="payTypeList">
                  <a-select  mode="multiple" placeholder="请选择支付方式"
                             style="width: 100%" v-model="queryParam.payTypeList" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.OrderPayTypeEnum" :value="item.type"
                                     :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
              </a-col>
              <a-col :md="6" :sm="24">
              </a-col>
              <a-col :md="6" :sm="24">
              </a-col>
            </template>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <a-tabs v-model="activeKey" @tabClick="changeTab">
        <a-tab-pane key="" tab="全部订单"/>
        <a-tab-pane v-for="pane in this.customDict.OrderSellMallStatusEnum" :key="pane.type" :tab="pane.name">
        </a-tab-pane>
      </a-tabs>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['order:sell:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['order:sell:export']">
          <a-icon type="download" />{{$t('选中导出')}}
        </a-button>
        <a-button type="primary" @click="handleDeliveryExport" v-hasPermi="['order:sell:export']">
          <a-icon type="download" />导出待发货
        </a-button>
        <a-button type="dashed" @click="$refs.importExcel.importExcelHandleOpen()"
                  v-hasPermi="['order:sell:delivery']">
          <a-icon type="import" />导入发货单
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <normal-detail-form ref="normalDetailForm" @ok="getList"/>
      <delivery-form ref="deliveryForm" @ok="getList"/>
      <logistic-detail ref="logisticDetail"/>
      <import-excel ref="importExcel" @ok="getList" />
      <amount-change ref="amountChange" @ok="getList" />
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1400' }"
        class="sticky-ant-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="orderStatus" slot-scope="text, record">
           <custom-dict-tag :options="customDict.OrderSellMallStatusEnum" :value="record.orderStatus"/>
        </span>
        <span slot="payType" slot-scope="text, record">
           <custom-dict-tag :options="customDict.OrderPayTypeEnum" :value="record.payType"/>
        </span>
        <span slot="isRemind" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :color="true" :color-array="['red','green']" :value="record.isRemind"/>
        </span>
        <span slot="isFirstOrder" slot-scope="text, record">
           <custom-dict-tag :options="customDict.TFEnum" :value="record.isFirstOrder"/>
        </span>
        <div slot="goodsTitle" style="width: 400px">
          <a-row>
            商品信息
          </a-row>
          <a-row>
            <a-col :span="16">sku名称</a-col>
            <a-col :span="3">图片</a-col>
            <a-col :span="3">数量</a-col>
          </a-row>
        </div>
        <div slot="orderItemList"  slot-scope="text, record">
          <a-table class="innerTable" :showHeader="false" size="small" :bordered="false"  rowKey="orderItemId"
                   :pagination="false" :columns="goodsColumns" :data-source="record.orderItemList">
            <template slot="picture" slot-scope="text, record">
              <div>
                <img v-if="record.picture" :src="record.picture"  style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt="none"/>
              </div>
            </template>
          </a-table>
        </div>
        <span slot="logisticsNo" slot-scope="text, record">
          <template v-if="record.logisticsNo">
            <template v-for="(logisticNo, index) in record.logisticsNo.split(',')">
<!--              <a @click="$refs.logisticDetail.handleDetailByNo(logisticNo.trim())">{{ logisticNo.trim() }}</a>-->
              <a @click="openLogistics(logisticNo.trim())">{{ logisticNo.trim() }}</a>
              <span v-if="index < record.logisticsNo.split(',').length - 1">, </span>
            </template>
          </template>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"/>
          <a @click="openOrderDetail(record)">
            <a-icon type="eye" />{{$t('详情')}}
          </a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"  @click="e => e.preventDefault()">
              <a-icon type="double-right" />
              {{$t('更多')}}
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['order:sell:cancel']" v-if="record.orderStatus===2010">
                <a @click="handleCancel(record)"  v-hasPermi="['order:sell:cancel']">
                  <a-icon type="edit" />{{$t('取消订单')}}
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['order:sell:amount']" v-if="record.orderStatus===2010">
                <a @click="$refs.amountChange.handleDetail(record.id)"  v-hasPermi="['order:sell:amount']">
                  <a-icon type="edit" />{{$t('订单改价')}}
                </a>
              </a-menu-item>
              <a-menu-item  v-if="record.orderStatus===2050">
                <a @click="jumpEvaluation(record.id)"  >
                  <a-icon type="edit" />{{$t('查看评价')}}
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['order:sell:prod']" v-if="record.orderStatus===2012 && record.isSplit">
                <a @click="handleProd(record)"  v-hasPermi="['order:sell:prod']">
                  <a-icon type="edit" />安排生产
                </a>
              </a-menu-item>
              <a-menu-item  v-if="record.orderStatus===2013">
                <a @click="handleProdFinish(record)" >
                  <a-icon type="edit" />生产完成
                </a>
              </a-menu-item>
                <a-menu-item  v-if="record.orderStatus===2030">
                <a @click="handleReceipt(record)">
                  <a-icon type="edit" />确认收货
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['order:sell:delivery']" v-if="(record.orderStatus===2020|| record.orderStatus===2025) && record.isSplit">
                <a @click="$refs.deliveryForm.handleDelivery(record.id)"  v-hasPermi="['order:sell:delivery']">
                  <a-icon type="edit" />{{$t('发货')}}
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageSell, prodSell, prodFinishSell, cancelSell, receiptSell} from '@/api/order/sell'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import ImportExcel from "./modules/ImportExcel";
import NormalDetailForm from './modules/NormalDetailForm.vue'
import { tableMixin } from '@/store/table-mixin'
import {platformCategoryList} from "@/api/goods/category";
import LogisticDetail from "./modules/LogisticDetail";
import DeliveryForm from "@/views/order/sell/modules/DeliveryForm";
import AmountChange from "./modules/AmountChange.vue";

export default {
  name: 'Sell',
  components: {
    CustomDictTag,
    ImportExcel,
    NormalDetailForm,
    DeliveryForm,
    LogisticDetail,
    AmountChange,
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      cateOptions: [],
      starList: [],
      activeKey: null,
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        buyerId: undefined,
        orderType: 20,
        goodsId: undefined,
        categoryId: undefined,
        goodsName: undefined,
        isPay: undefined,
        outTradeNo: undefined,
        buyerName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        deliveryBeginTime: undefined,
        deliveryEndTime: undefined,
        payType: undefined,
        payTime: undefined,
        userMobile: undefined,
        orderStatus: undefined,
        orderStatusList: undefined,
        refundStatusList: undefined,
        payTypeList: undefined,
        refundStatus: undefined,
        isFirstOrder: undefined,
        isRemind: undefined,
        isError: undefined,
        saleEndDate: undefined,
        saleEndTime: undefined,
        errorUpdateTimeStart: undefined,
        errorUpdateTimeEnd: undefined,
        pageNum: 1,
        pageSize: 10
      },

      goodsColumns:[
        {
          dataIndex: 'skuName',
          width:200,
          align: 'center',
        },
        {
          dataIndex: 'picture',
          width:50,
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          width:50,
          dataIndex: 'goodsCount',
          align: 'center'
        },
      ],

      columns: [
        {
          title: this.$t('订单编号'),
          dataIndex: 'id',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center',
          width: '155px',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          scopedSlots: { customRender: 'orderStatus' },
          width: '100px',
          align: 'center'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
          sorter: 1,
          width: '180px',
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '买家ID',
          dataIndex: 'buyerId',
          width: '65px',
          align: 'center'
        },
        {
          title: '买家名称',
          dataIndex: 'buyerName',
          width: '100px',
          align: 'center'
        },
        {
          title: '催发货',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'isRemind' },
          dataIndex: 'isRemind',
          width: '80px',
          align: 'center'
        },
        {
          title: '商品数量',
          sorter: 1,
          width: '100px',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'goodsCount',
          align: 'center'
        },
        {
          title: '商品名称',
          width: '150px',
          dataIndex: 'goodsName',
          //ellipsis: true,
          align: 'center'
        },
        {
          width: 400,
          dataIndex: 'orderItemList',
          scopedSlots: { customRender: 'orderItemList' },
          slots: { title: 'goodsTitle' },
          align: 'center'
        },
        {
          title: '订单原价',
          sorter: 1,
          width: '100px',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'orderAmount',
          align: 'center'
        },
        {
          title: '实付金额',
          sorter: 1,
          width: '100px',
          sortDirections: ['descend', 'ascend'],
          dataIndex: 'payAmount',
          align: 'center'
        },
        {
          title: '运费',
          width: '75px',
          dataIndex: 'shippingPayAmount',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          align: 'center'
        },
        {
          title: '三方订单号',
          width: '120px',
          dataIndex: 'outTradeNo',
          align: 'center'
        },
        {
          title: '支付方式',
          width: '100px',
          scopedSlots: { customRender: 'payType' },
          dataIndex: 'payTypeName',
          align: 'center'
        },
        {
          title: '支付时间',
          dataIndex: 'payTime',
          width: '100px',
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'payTime' },
          align: 'center'
        },
        {
          title: '期望发货时间',
          width: '100px',
          dataIndex: 'deliveryDate',
          align: 'center'
        },
        {
          title: this.$t('退款状态'),
          width: '100px',
          dataIndex: 'refundStatusName',
          align: 'center'
        },
        /*{
          title: this.$t('是否首单'),
          sorter: 1,
          sortDirections: ['descend', 'ascend'],
          scopedSlots: { customRender: 'isFirstOrder' },
          dataIndex: 'isFirstOrder',
          align: 'center'
        },*/
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {
  },
  created () {
    //this.getCategoryList();
    this.getOrderRouteList()
  },
  watch: {
    $route:'getOrderRouteList'
  },
  mounted() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    getOrderRouteList() {
      let params = this.$route.params;
      console.log('订单params',params)
      if (params.buyerId) {
        this.queryParam.buyerId = params.buyerId
        this.queryParam.isPay = params.isPay
      }
      if (params) {
        for (let key in params) {
          if (this.queryParam.hasOwnProperty(key)) {
            this.queryParam[key] = params[key];
          }
        }
      }
      this.getList();
    },
    /** 查询销售订单列表 */
    getList () {
      this.loading = true
     pageSell(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
        this.$nextTick(() => this._stickyUpdate && this._stickyUpdate())
      })
    },
    openOrderDetail(record) {
      this.$refs.normalDetailForm.handleDetail(record.id);
    },
    openLogistics(no) {
      const url = new URL('https://www.kuaidi100.com/chaxun');
      url.searchParams.set('nu', no);
      window.open(url.toString(), "_blank");
    },
    orderStatusListChange() {
      this.queryParam.orderStatus = undefined;
    },
    //切换tab
    changeTab(index) {
      if (index == null) {
        index = undefined;
      }
      this.queryParam.orderStatus = index;
      this.getList();
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    handleQueryUnit () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    jumpEvaluation(orderId) {
      this.$router.push({
        path: '/goods/goods/evaluate',
        query: {
          orderId: orderId,
        }
      })
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        id:undefined,
        buyerId:undefined,
        goodsId: undefined,
        orderType: 20,
        categoryId: undefined,
        goodsName: undefined,
        isPay:undefined,
        outTradeNo: undefined,
        buyerName: undefined,
        orderStatusList: undefined,
        refundStatusList: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        deliveryBeginTime: undefined,
        deliveryEndTime: undefined,
        payType: undefined,
        payTypeList: undefined,
        payTime: undefined,
        userMobile:undefined,
        orderStatus: undefined,
        refundStatus: undefined,
        isFirstOrder: undefined,
        isRemind: undefined,
        isError: undefined,
        saleEndDate: undefined,
        saleEndTime: undefined,
        errorUpdateTimeStart: undefined,
        errorUpdateTimeEnd: undefined,
        pageNum: 1,
        pageSize: 10
      };
      this.activeKey=''
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /*页面初始化时获取分类类别*/
    getCategoryList() {
      platformCategoryList({}).then(response => {
        this.categoryList = response.data;
        let children = this.handleTree(response.data, 'id', 'pid')
        console.log('children', children)
        this.cateOptions = children
      })
    },


    handleCancel(record) {
      var that = this
      this.$confirm({
        title: this.$t('确认取消'),
        onOk () {
          return cancelSell({id:record.id})
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('取消成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel () {}
      })
      this.getList();
    },
    handleReceipt(record) {
      var that = this
      this.$confirm({
        title: '是否确认收货?',
        onOk () {
          return receiptSell({id:record.id}).then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = '收货成功'
              that.$message.success(message, 3)
            })
        },
        onCancel () {}
      })
      this.getList();
    },
    handleProd(record) {
      var that = this
      this.$confirm({
        title: '是否确认进入生产?',
        onOk () {
          return prodSell({id:record.id}).then(() => {
            that.onSelectChange([], [])
            that.getList()
            const message = '进入生产'
            that.$message.success(message, 3)
          })
        },
        onCancel () {}
      })
      this.getList();
    },
    handleProdFinish(record) {
      var that = this
      this.$confirm({
        title: '是否确认生产完成?',
        onOk () {
          return prodFinishSell({id:record.id}).then(() => {
            that.onSelectChange([], [])
            that.getList()
            const message = '生产完成'
            that.$message.success(message, 3)
          })
        },
        onCancel () {}
      })
      this.getList();
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/order/sell/export',
            that.queryParam
          , `销售订单_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },

    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出选中数据'),
        onOk () {
          that.download('biz/admin/order/sell/export', queryParam, `销售订单_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple=true
          that.selectedRowKeys=[]
        }
      })
    },

    handleDeliveryExport() {
      var that = this
      let queryForm = {
        idList: this.ids,
        orderType: 20,
        goodsId: this.queryParam.goodsId,
        goodsName: this.queryParam.goodsName,
        createBeginTime: this.queryParam.createBeginTime,
        createEndTime: this.queryParam.createEndTime,
        goodsType: this.queryParam.goodsType,
        isRemind: this.queryParam.isRemind,
        deliveryBeginTime: this.queryParam.deliveryBeginTime,
        deliveryEndTime: this.queryParam.deliveryEndTime
      };

      this.$confirm({
        title: this.$t('是否确认导出'),
        content: '此操作将导出所有待发货订单, 不包含申请退款中的订单, 导出的商品数量为总商品减去已退款的数量',
        onOk () {
          that.download('biz/admin/order/sell/delivery/export', queryForm, `发货清单_${new Date().getTime()}.zip`)

        },
        onCancel () {}
      })
      this.ids=[]
      this.multiple=true
      this.selectedRowKeys=[]
    },
  }
}
</script>
